import { render, staticRenderFns } from "./SubscriberWrapper.vue?vue&type=template&id=5942f39a&scoped=true"
import script from "./SubscriberWrapper.vue?vue&type=script&lang=js"
export * from "./SubscriberWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5942f39a",
  null
  
)

export default component.exports